module.exports = __webpack_public_path__ + "img/pro_seven_3.f5a28347.jpg";